module.exports = __webpack_public_path__ + "img/io_logo.a765217e.png";